var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2PartlyCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 441.1 290.4",
    style: {
      enableBackground: "new 0 0 441.1 290.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M118.6,157.4c21.4,0,38.8-17.4,38.8-38.8S140,79.8,118.6,79.8s-38.8,17.4-38.8,38.8S97.2,157.4,118.6,157.4z M118.6,170.7 c-28.8,0-52.1-23.3-52.1-52.1s23.3-52.1,52.1-52.1s52.1,23.3,52.1,52.1S147.3,170.7,118.6,170.7z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 187)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-16.1-77.3H16c4.9,0,8.9,4,8.9,8.9l0,0c0,4.9-4,8.9-8.9,8.9h-32.1c-4.9,0-8.9-4-8.9-8.9l0,0 C-25-73.3-21-77.3-16.1-77.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.2-77.3h32.1c4.9,0,8.9,4,8.9,8.9l0,0c0,4.9-4,8.9-8.9,8.9h-32.1c-4.9,0-8.9-4-8.9-8.9l0,0 C162.3-73.3,166.3-77.3,171.2-77.3z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45 345.229 71.322)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.9-64.4H74c4.9,0,8.9,4,8.9,8.9l0,0c0,4.9-4,8.9-8.9,8.9H41.9c-4.9,0-8.9-4-8.9-8.9l0,0 C33-60.5,37-64.4,41.9-64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.2-64.4h32.1c4.9,0,8.9,4,8.9,8.9l0,0c0,4.9-4,8.9-8.9,8.9h-32.1c-4.9,0-8.9-4-8.9-8.9l0,0 C220.3-60.5,224.3-64.4,229.2-64.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 -106.229 131.678)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-66.3-45.4h32.1c4.9,0,8.9,4,8.9,8.9l0,0c0,4.9-4,8.9-8.9,8.9h-32.1c-4.9,0-8.9-4-8.9-8.9l0,0 C-75.1-41.5-71.2-45.4-66.3-45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121-45.4h32.1c4.9,0,8.9,4,8.9,8.9l0,0c0,4.9-4,8.9-8.9,8.9H121c-4.9,0-8.9-4-8.9-8.9l0,0 C112.2-41.5,116.1-45.4,121-45.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124 88)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-5.4-88L-5.4-88c4.9,0,8.9,4,8.9,8.9V-47c0,4.9-4,8.9-8.9,8.9l0,0c-4.9,0-8.9-4-8.9-8.9v-32.1 C-14.3-84-10.3-88-5.4-88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-5.4,100.4L-5.4,100.4c4.9,0,8.9,4,8.9,8.9v32.1c0,4.9-4,8.9-8.9,8.9l0,0c-4.9,0-8.9-4-8.9-8.9v-32.1 C-14.3,104.4-10.3,100.4-5.4,100.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.2,64.3c-50.7,0-92.8,38.9-97,89.1l-0.4,5.1h-11c-34.9,0-63.2,28.3-63.2,63.2s28.3,63.2,63.2,63.2h218.3 c42.2,0,76.5-34.2,76.5-76.5s-34.2-76.5-76.5-76.5c-4,0-8,0.3-11.9,0.9l-4.5,0.7l-1.7-4.3C327.4,90.6,290.8,64.3,249.2,64.3 L249.2,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.2,75.4c-44.9,0-82.3,34.5-86,79l-1.3,15.2h-21.2c-28.8,0-52.1,23.3-52.1,52.1c0,28.8,23.3,52.1,52.1,52.1H359 c36.1,0,65.4-29.3,65.4-65.4S395.1,143,359,143c-3.5,0-6.9,0.3-10.2,0.8l-13.6,2.1l-4.6-13C318.5,98.7,286.1,75.4,249.2,75.4 L249.2,75.4z M249.2,58.8c44.8,0,82.9,28.6,97.1,68.6c4.2-0.7,8.5-1,12.8-1c45.3,0,82,36.7,82,82s-36.7,82-82,82H140.7 c-37.9,0-68.7-30.8-68.7-68.7c0-37.9,30.8-68.7,68.7-68.7h5.9C151.1,100.2,195.3,58.8,249.2,58.8L249.2,58.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2PartlyCloudy);
export default __webpack_public_path__ + "static/media/2_partly_cloudy.af8c25b0d0619916c4e6ad9dc9cddc26.svg";
export { ForwardRef as ReactComponent };